<!--
Tooltip component to be used for tooltips which are generally loaded AFTER the inital page load.
-->
<template>
    <abbr class="ml-2" ref="tooltip" :title="infoText">
        <InfoIcon classes="svg-icon icon-tooltip svg-icon--small@large"></InfoIcon>
    </abbr>
</template>

<script>
    import InfoIcon from "./InfoIcon";

    export default {
        name: "Tooltip",
        props: ['infoText'],// add classes for styling
        components: {InfoIcon},
        data() {
            return {
            }
        },
        mounted() {
            this.$refs.tooltip.addEventListener( 'mouseenter', window.Prj.JqueryToolTip.bindToolTip )
        }
    }
</script>
